var _polygon, _line, _line2, _line3, _line4, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiletype(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "stroke-color-main",
    points: "44.689 175.365 44.689 20.775 119.7 20.775 155.311 57.033 155.311 175.365 44.689 175.365"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "stroke-color-main",
    x1: 64.767,
    y1: 86.351,
    x2: 136.748,
    y2: 86.351
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "stroke-color-main",
    x1: 64.767,
    y1: 113.355,
    x2: 136.748,
    y2: 113.355
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "stroke-color-main",
    x1: 64.767,
    y1: 140.358,
    x2: 136.748,
    y2: 140.358
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "stroke-color-main",
    x1: 64.767,
    y1: 59.348,
    x2: 100.379,
    y2: 59.348
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "stroke-color-main",
    points: "117.427 22.259 117.427 58.962 155.311 58.962"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiletype);
export default __webpack_public_path__ + "static/media/filetype.0e39cb06187153db5c0b11a85823f541.svg";
export { ForwardRef as ReactComponent };